var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "loader_svg__eSUTOYEng2N1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "-5 -5 160 160"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes p1_scale__ts{0%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25)}75%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}90%,to{transform:translate(75.000495px,75.111757px) scale(1,1)}}@keyframes p1_c_o{0%{opacity:0}75%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}90%,to{opacity:1}}@keyframes p2_scale__ts{0%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25)}60%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}75%,to{transform:translate(75.000495px,75.111757px) scale(1,1)}}@keyframes p2_c_o{0%{opacity:0}60%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}75%,to{opacity:1}}@keyframes p3_scale__ts{0%{transform:translate(75.000495px,74.982204px) scale(1.25,1.25)}45%{transform:translate(75.000495px,74.982204px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}60%,to{transform:translate(75.000495px,74.982204px) scale(1,1)}}@keyframes p3_c_o{0%{opacity:0}45%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}60%,to{opacity:1}}@keyframes p4_scale__ts{0%{transform:translate(75.000495px,74.982204px) scale(1.25,1.25)}30%{transform:translate(75.000495px,74.982204px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}45%,to{transform:translate(75.000495px,74.982204px) scale(1,1)}}@keyframes p4_c_o{0%{opacity:0}30%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}45%,to{opacity:1}}@keyframes p5_scale__ts{0%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25)}15%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}30%,to{transform:translate(75.000495px,75.111757px) scale(1,1)}}@keyframes p5_c_o{0%{opacity:0}15%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}30%,to{opacity:1}}@keyframes p0_scale__ts{0%{transform:translate(75.000495px,75.111757px) scale(1.25,1.25);animation-timing-function:cubic-bezier(0,0,.58,1)}15%,to{transform:translate(75.000495px,75.111757px) scale(1,1)}}@keyframes p0_c_o{0%{opacity:0;animation-timing-function:cubic-bezier(0,0,.58,1)}15%,to{opacity:1}}")), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p0_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "m63.19 53.6 43.8-25.3c.8-.5 1-1.5.5-2.2-10.4-15.6-27.3-24.7-45-25.9-.9-.1-1.7.7-1.7 1.6v50.5c0 1.1 1.3 1.9 2.4 1.3Z",
    opacity: 100,
    style: {
      animation: "p0_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.332)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p1_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M29.39 7.9c-8.1 4.7-14.6 11-19.5 18.2-.5.8-.3 1.8.5 2.2l43.7 25.2c1.1.6 2.4-.2 2.4-1.4V1.6c0-.9-.8-1.6-1.7-1.6-8.6.7-17.3 3.2-25.4 7.9Z",
    opacity: 100,
    style: {
      animation: "p1_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.332)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p2_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M6.09 32.7c-7.8 15.9-8.4 35.1-.1 51.9.4.8 1.4 1.1 2.2.7L51.99 60c1.1-.6 1.1-2.1 0-2.7L8.29 32.1c-.7-.5-1.8-.2-2.2.6Z",
    opacity: 100,
    style: {
      animation: "p2_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.332)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p3_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M9.89 91.2c10.4 15.6 27.3 24.7 45 25.9.9.1 1.7-.7 1.7-1.6V65c0-1.2-1.3-2-2.4-1.4l-43.8 25.3c-.8.5-1 1.5-.5 2.3Z",
    opacity: 100,
    style: {
      animation: "p3_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.17)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p4_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M87.99 109.3c8.1-4.7 14.6-11 19.5-18.2.5-.8.3-1.8-.5-2.2l-43.8-25.3c-1.1-.6-2.4.2-2.4 1.4v50.5c0 .9.8 1.6 1.7 1.6 8.7-.6 17.4-3.1 25.5-7.8Z",
    opacity: 100,
    style: {
      animation: "p4_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.17)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "p5_scale__ts 3000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "m109.09 32-43.8 25.2c-1.1.6-1.1 2.1 0 2.7l43.7 25.2c.8.5 1.8.1 2.2-.7 7.8-15.9 8.4-35.1.1-51.9-.4-.7-1.4-1-2.2-.5Z",
    opacity: 100,
    style: {
      animation: "p5_c_o 3000ms linear infinite normal forwards"
    },
    transform: "matrix(1.25 0 0 1.25 -73.3 -73.332)"
  })));
};
export default SvgLoader;